<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Affiliates</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <b>Affiliate List</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <div class="row mb-3">
            <router-link
              :to="{ name: 'affiliate-add' }"
              type="button"
              class="btn btn-primary ml-4 float-left"
              >Add</router-link
            >

              <div
                class="col-12 d-flex flex-column flex-sm-row pr-4"
              >
                <span class="m-auto"></span>

                <div
                  class="btn-group"
                  role="group"
                >
                  <button
                    class="btn btn-secondary"
                    id="btn-inactive"
                    type="button"
                    :class="this.active ? 'change-background': ''"
                    @click="changeStatus()"
                  >
                    Active
                  </button>
                  <button
                    class="btn btn-secondary"
                    id="btn-inactive"
                    type="button"
                    :class="!this.active ? 'change-background': ''"
                    @click="changeStatus()"
                  >
                    Inactive
                  </button>
                </div>
              </div>
            </div>

            <div v-show="this.active" class="table-responsive">
              <table
                id="table"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Mobile Number</th>
                    <th>Office Number</th>
                    <th>Email</th>
                    <th>Social Media</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in active_lists" :key="index">
                    <td>{{index + 1}}</td>
                    <td>
                      {{list.name}}
                    </td>
                    <td>{{list.status ? 'Active' : 'Inactive'}}</td>
                    <td>{{list.mobile_no}}</td>
                    <td>{{list.office_no}}</td>
                    <td>{{list.email}}</td>
                    <td>
                      <a v-show="list.facebook != null" :href="list.facebook" target="_blank" >Facebook</a>
                      <br />
                      <a v-show="list.instagram != null" :href="list.instagram" target="_blank" >Instagram</a>
                    </td>
                    <td>
                      <router-link
                        :to="goTo(list.id, 'referal')"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-show="!this.active" class="table-responsive">
              <table
                id="table"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Mobile Number</th>
                    <th>Office Number</th>
                    <th>Email</th>
                    <th>Social Media</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in inactive_lists" :key="index">
                    <td>{{index + 1}}</td>
                    <td>
                      {{list.name}}
                    </td>
                    <td>{{list.status ? 'Active' : 'Inactive'}}</td>
                    <td>{{list.mobile_no}}</td>
                    <td>{{list.office_no}}</td>
                    <td>{{list.email}}</td>
                    <td>
                      <a v-show="list.facebook != null" :href="list.facebook" target="_blank" >Facebook</a>
                      <br />
                      <a v-show="list.instagram != null" :href="list.instagram" target="_blank" >Instagram</a>
                    </td>
                    <td>
                      <router-link
                        :to="goTo(list.id, 'referal')"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
      ></loading>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "affiliates",
  components: {
    Loading
  },

  data() {
    return {
      active_lists: [],
      inactive_lists: [],
      active: true,
      isLoading: false,
      fullPage: true,
    };
  },

  methods: {
    async loadData() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null || token === '') {
        console.log("Not Authorised.")
        return;
      }

      token = JSON.parse(token);
      token = token.access_token;
      try {
        let result = await axios.get(axios.lpsURL + "/affiliate", {
          headers: {
            Authorization: "Bearer " + token
          }
        });
        result.data.forEach(item => {
          if(!item.status) {
            this.inactive_lists.push(item)
          } else {
            this.active_lists.push(item)
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    goTo(id, type) {
      return type === 'referal' ? `/lps/affiliate/referral/${id}` : `/lps/affiliate/edit/${id}`;
    },

    changeStatus() {
      this.active = !this.active
    },

    killDatatable() {
      $(".table")
        .DataTable()
        .destroy();
    },

    createDatatable() {
      $(".table").DataTable({
         dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5]
            },
             filename: 'Affiliate List',
             title: 'Affiliate List',
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5]
            },
            filename: 'Affiliate List',
            title: 'Affiliate List',

          }
        ]
      });
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {
    this.isLoading = true;
    await this.loadData();
    this.createDatatable();
    this.isLoading = false;
  },

  mounted() {}
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
